/* eslint-disable react/require-default-props */
import React from 'react';
import TasksPage from 'components/organisms/tasks_page';
import { BiddingData, BiddingState } from 'store/modules/bidding_store/types';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import BiddingClientAttachments from 'components/molecules/bidding_client_attachments';
import ManagementMonitoring from 'components/molecules/management_monitoring';
import { ProfileState } from 'store/modules/profile_store/types';
import DocumentsSellingPage from 'components/molecules/documents_selling_page';
import { ResultBody } from 'components/molecules/result_body';
import { FeatureType } from 'store/modules/management_store/types';
import BiddingCommentsList from '../bidding_comments_list';

interface BiddingDetailsProps {
  bidding: BiddingData;
  selectedFeature: FeatureType;
  setSelectedFeature: (feature: FeatureType) => void;
}

const BiddingDetailTools = (props: BiddingDetailsProps) => {
  const { bidding, selectedFeature, setSelectedFeature } = props;
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { biddings } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="d-flex flex-nowrap overflow-auto">
            <button
              className={`btn btn-link mr-2 tab ${
                selectedFeature === 'tasks' ? 'text-dark rounded-top bg-white' : ''
              }`}
              type="button"
              onClick={() => setSelectedFeature('tasks')}
            >
              Tarefas
            </button>
            <button
              className={`btn btn-link mx-2 tab ${
                selectedFeature === 'comments' ? 'text-dark rounded-top bg-white' : ''
              }`}
              type="button"
              onClick={() => setSelectedFeature('comments')}
            >
              Anotações
            </button>
            <button
              className={`btn btn-link mx-2 tab ${
                selectedFeature === 'attachments' ? 'text-dark rounded-top bg-white' : ''
              }`}
              type="button"
              onClick={() => setSelectedFeature('attachments')}
            >
              Anexos
            </button>
            <button
              className={`btn btn-link mx-2 tab ${
                selectedFeature === 'results' ? 'text-dark rounded-top bg-white' : ''
              }`}
              type="button"
              onClick={() => setSelectedFeature('results')}
            >
              Resultados
            </button>
            <button
              className={`btn btn-link mx-2 tab ${
                selectedFeature === 'documents' ? 'text-dark rounded-top bg-white' : ''
              }`}
              type="button"
              onClick={() => setSelectedFeature('documents')}
            >
              Habilitação
            </button>
            {bidding.has_electronic_trading && (
              <button
                className={`btn btn-link mx-2 tab ${
                  selectedFeature === 'monitoring' ? 'text-dark rounded-top bg-white' : ''
                }`}
                type="button"
                onClick={() => setSelectedFeature('monitoring')}
              >
                Monitorar Chat
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="shadow bg-white">
            {selectedFeature === 'tasks' && <TasksPage bidding={bidding} source="details" />}
            {selectedFeature === 'comments' && (
              <div className="p-3">
                <BiddingCommentsList
                  biddingId={bidding.id}
                  comments={
                    biddings.bidding_list.find((currentBidding) => currentBidding.id === bidding.id)
                      ?.client_comments || []
                  }
                />
              </div>
            )}
            {selectedFeature === 'attachments' && (
              <div className="p-3">
                <BiddingClientAttachments biddingId={bidding.id} source="attachments" />
              </div>
            )}
            {selectedFeature === 'documents' && (
              <div className="p-3">
                {(!profile.can_use_my_documents || !profile.has_documents_company) && (
                  <DocumentsSellingPage />
                )}
                {profile.can_use_my_documents && profile.has_documents_company && (
                  <BiddingClientAttachments biddingId={bidding.id} source="documents" />
                )}
              </div>
            )}
            {selectedFeature === 'results' && (
              <div className="p-3">
                <ResultBody bidding_id={bidding.id.toString()} />
              </div>
            )}
            {selectedFeature === 'monitoring' && (
              <ManagementMonitoring electronicTradingId={bidding.electronic_trading.id} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BiddingDetailTools;
